export const SITE_METADATA = {
  canonicalUrl: "https://backbonesystems.ai/",
  description:
    "Backbone simplifies payments so healthcare teams move faster, with more clarity, and spend their time where it matters.",
  domain: "backbonesystems.ai",
  headline: "The clinical intelligence behind healthcare payments.",
  imageAlt: "Backbone — Clinical intelligence for healthcare payments.",
  imageHeight: 630,
  imagePath: "/link-preview.png",
  imageUrl: "https://backbonesystems.ai/link-preview.png",
  imageWidth: 1200,
  siteName: "Backbone",
  themeColor: "#f5f5f5",
  title: "Backbone — Clinical intelligence for healthcare payments",
} as const;
